export const contractScheduleError = form => {
  const start = form.scheduled_at ? new Date(form.scheduled_at) : null;
  const end = form.pickup_at ? new Date(form.pickup_at) : null;
  if (
    (start && Number.isNaN(start.getTime())) ||
    (end && Number.isNaN(end.getTime()))
  ) {
    return 'Confira a data e o horário de entrega e retirada.';
  }
  if (end && !start) return 'Informe a entrega antes de definir a retirada.';
  if (start && end && end < start)
    return 'A retirada deve ocorrer na mesma data e horário da entrega ou depois.';
  return '';
};

export const contractStepError = (step, form, items) => {
  if (step === 0 && !form.recipient_name?.trim())
    return 'Informe o nome do cliente para continuar.';
  if (step === 1) {
    if (!items.length) return 'Adicione pelo menos um produto ou serviço.';
    if (
      items.some(
        item =>
          !item.product_name?.trim() ||
          !Number.isFinite(Number(item.quantity)) ||
          Number(item.quantity) <= 0 ||
          !Number.isFinite(Number(item.unit_price)) ||
          Number(item.unit_price) < 0
      )
    ) {
      return 'Confira a descrição, quantidade e valor dos itens.';
    }
  }
  if (step === 2) {
    const scheduleError = contractScheduleError(form);
    if (scheduleError) return scheduleError;
    if (!form.payment_method?.trim())
      return 'Selecione a forma de pagamento combinada com o cliente.';
  }
  return '';
};
